import React, { Component } from 'react'
import classNames from 'classnames';

export default class WrapperPanel extends Component {
    render() {
        return (
            <div className={classNames(
                "wrapper-panel fixed top-16 left-0 right-0 w-full h-[calc(100vh-64px)]",
                "overflow-y-auto bg-inherit text-[#eee] font-sans font-semibold p-5 box-border z-[1]",
                "custom-scrollbar" // Adding custom scrollbar style here too as it's scrollable
            )}>
                {this.props.children}
            </div>
        )
    }
}
